export const PRODUCT_CHARACTERISTICS_MAP = [
    { key: "fabric", label: "Тип ткани" },
    { key: "seasonEcom", label: "Сезон" },
    { key: "directionOfStyle", label: "Направление стиля" },
    { key: "print", label: "Тип принта" },
    { key: "embroidery", label: "Тип вышивки" },
    { key: "other", label: "Дополнительно" },
    { key: "fit", label: "Посадка" },
    { key: "length", label: "Длина" },
    { key: "sleeveLength", label: "Длина рукава" },
] as const;
